const rqParams = {
  /**
   * 教师-创建或更新班级信息
   */
  createClassInfo(param) {
    return {
      op_path: 'yjclass.classinfo.createclassinfo',
      noJumpTo: true,
      ...param
    }
  },
  /**
   * 教师-获取班级列表
   */
  getClassInfoList(param) {
    return {
      op_path: 'yjclass.classinfo.getclassinfolist',
      ...param
    }
  }
}
export default rqParams
